import React from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import InvestorManagementTable from "./table"

const InvestorManagement = () => {
  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"List"} />
          <InvestorManagementTable />
        </Container>
      </div>
    </>
  )
}

export default InvestorManagement
